import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const Retrospection: Portfolio = {
    path: "retrospection", name: "Retrospection", pageStyle: PageStyle.Tan, pieces: [
        {image: "retrospection-01.jpg", thumbAlt: "Retrospection", title: "10", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-02.jpg", thumbAlt: "Retrospection", title: "Alone", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-03.jpg", thumbAlt: "Retrospection", title: "Approach", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-04.jpg", thumbAlt: "Retrospection", title: "Blue House", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-05.jpg", thumbAlt: "Retrospection", title: "Careful", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-06.jpg", thumbAlt: "Retrospection", title: "Elemental", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-07.jpg", thumbAlt: "Retrospection", title: "Immigrants", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-08.jpg", thumbAlt: "Retrospection", title: "Pear", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-09.jpg", thumbAlt: "Retrospection", title: "The Point", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-10.jpg", thumbAlt: "Retrospection", title: "Time Capsule", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-11.jpg", thumbAlt: "Retrospection", title: "Totem", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "retrospection-12.jpg", thumbAlt: "Retrospection", title: "Understanding", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
    ],
    piecesColumns: 6,
    statement: {
        leftColumn: [
            "Looking back and looking inward…these prints use pieces of creative time and represent whole " +
            "explorations, inquiries, and investigations of multiple subjects throughout the last years of my " +
            "printmaking practice. My life travels before my eyes as I use fragments of inspirations that " +
            "compelled me to study a subject, immerse myself, then enter the studio …literally tear it to pieces " +
            "and abstract it to discover a symbol or a meaning that informs me of personal truths previously not " +
            "known to me or at least not noticed.",
            "The natural world and its complexities and mysteries provide a mirror for learning.",
            "Plankton became “the mother.” Bowerbirds,“the artists.” Beaver, “the builders.” Prairie Dogs, " +
            "“the stewards.” The natural world provides me with archetypes, symbols, markers for inquiry and " +
            "study. Ultimately, the essence is emphasized, rather than the figurative. The visual language " +
            "became more abstract."
        ],
        rightColumn: [
            "These collages serve to further abstract and construct images of feelings, emotions, and symbols, " +
            "this time using pieces of the past, building wisps, ephemeral thoughts, haikus of ideas. Each piece " +
            "carries a story, but is used in a new way to distill, rather than to narrate.",
            "The elements carry the past…the resolution acknowledges the present.",
            "Erika Radich\n" +
            "September 2018"
        ]
    }
};

export default Retrospection;